import React from "react";

const Select = ({ id, name, value, setValue, defaultOption, options }) => {
  const handleOnChange = (e) => {
    e.preventDefault();
    setValue(e.target.value);
  };

  return (
    <select
      id={id}
      name={name}
      className="text-sm border border-gray-300 rounded-md py-1.5 px-2
                 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
      value={value}
      onChange={handleOnChange}
    >
      <option value={defaultOption.value}>{defaultOption.label}</option>

      {options.map((option) => (
        <option key={option.key} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default Select;
